import AOS from 'aos/dist/aos.js';

export default {
  init() {
    AOS.init();
    $('.sidebar-menu').css('visibility', 'hidden');
    $('.header__nav-left, .header__burger').click( function (e) {
      e.preventDefault();
      $('html, body').addClass('body-hidden');
      $('.sidebar-menu').addClass('active');
      $('.sidebar-menu').css('visibility', 'visible');
    });
    $('.close-button, .closer, #navigation-mobile li, #navigation li').click( function () {
      // e.preventDefault();
      $('html, body').removeClass('body-hidden');
      $('.sidebar-menu').removeClass('active');
      setTimeout(function () {
        $('.sidebar-menu').css('visibility', 'hidden');
      }, 500);
    });
    jQuery(function($){
      $(document).mouseup(function (e){
        if(jQuery('.sidebar-menu').hasClass('active')) {
          var div = $('.mobile-menu');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.sidebar-menu').removeClass('active');
            setTimeout(function () {
              $('.sidebar-menu').css('visibility', 'hidden');
            }, 500);
            $('html, body').removeClass('body-hidden')
          }
        }
      });
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
